const getRowCount = table => table.get('rows') ||
    table.get('rowCount') ||
    table.get('rowHeights')?.size;

export default getRowCount;
